import React from "react";

const Product_Card = ({ img, heading, subheading, price }) => {
  return (
    <>
      <div className="card">
        <div className="card-img-wrapper">
          <img src={img} alt={heading} />
        </div>
        <div className="card-body text-start">
          <h3 className="card-title text-start">{heading}</h3>
          <p className="">{subheading}</p>
          <strong className="dollar">{price}</strong>
        </div>
      </div>
    </>
  );
};

export default Product_Card;
